export default [
    {
        id: 1,
        label: {
            en: 'Didn\'t fit',
            et: 'Ei sobinud',
            ru: 'Не подошло',
            lv: "Nederēja",
            lt: "Netiko",
            fi: "Ei sopinut",
        },
    },
    {
        id: 2,
        label: {
            en: 'Mistake',
            et: 'Viga',
            ru: 'Ошибка',
            lv: "Kļūda",
            lt: "Klaida",
            fi: "Virhe",
        },
    },
    {
        id: 3,
        label: {
            en: 'Customer refused',
            et: 'Klient keeldus',
            ru: 'Отказ клиента',
            lv: "Klients atteicās",
            lt: "Klientas atsisakė",
            fi: "Asiakas kieltäytyi",
        },
    },
    {
        id: 4,
        label: {
            en: 'Customer did not show up',
            et: 'Klient ei ilmunud kohale',
            ru: 'Клиент не явился',
            lv: "Klients neieradās",
            lt: "Klientas neatvyko",
            fi: "Asiakas ei saapunut",
        },
    },
    {
        id: 5,
        label: {
            en: 'Warranty',
            et: 'Garantii',
            ru: 'Гарантия',
            lv: "Garantija",
            lt: "Garantija",
            fi: "Takuu",
        },
    },
    {
        id: 6,
        label: {
            en: 'Defective product',
            et: 'Defektne toode',
            ru: 'Бракованный товар',
            lv: "Bojāta prece",
            lt: "Brokuota prekė",
            fi: "Viallinen tuote",
        },
    },
    {
        id: 7,
        label: {
            en: 'Body',
            et: 'Korpus',
            ru: 'Корпус',
            lv: "Korpuss",
            lt: "Korpusas",
            fi: "Runko",
        },
    },
    {
        id: 9,
        label: {
            en: 'Another reason',
            et: 'Muu põhjus',
            ru: 'Другая причина',
            lv: "Cits iemesls",
            lt: "Kita priežastis",
            fi: "Muu syy",
        },
    },
]